import { useNavigate } from 'react-router-dom';
import { serviceCategories } from '../../../mocks/services';
import useInView from '../../../hooks/useInView';

const ServicesOverview = () => {
  const navigate = useNavigate();
  const { ref, inView } = useInView();
  const { ref: ctaRef, inView: ctaInView } = useInView();

  return (
    <section id="services" className="py-10 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`text-center mb-10 md:mb-16 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">What We Do</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#111827] mb-4 sm:mb-5">
            Complete Home Service Solutions
          </h2>
          <p className="text-base sm:text-lg text-[#6B7280] max-w-2xl mx-auto">
            One company for every system in your home. From HVAC to plumbing, electrical to energy efficiency. Renova delivers expert service at every level.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 mb-8 sm:mb-12">
          {serviceCategories.map((s, i) => (
            <button
              key={s.id}
              onClick={() => navigate(s.path)}
              style={{ transitionDelay: `${i * 80}ms` }}
              className={`group flex flex-col items-center text-center p-4 sm:p-6 rounded-xl border border-[#E2E8F0] hover:border-[#C41E3A]/30 hover:bg-[#FEF2F2] transition-all duration-500 cursor-pointer ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              <div className="w-11 h-11 sm:w-14 sm:h-14 rounded-xl bg-[#F8F9FB] group-hover:bg-[#C41E3A] flex items-center justify-center mb-3 sm:mb-4 transition-colors duration-200">
                <i className={`${s.icon} text-xl sm:text-2xl text-[#C41E3A] group-hover:text-white transition-colors`} />
              </div>
              <h3 className="text-xs sm:text-sm font-bold text-[#111827] mb-1 sm:mb-2">{s.title}</h3>
              <p className="text-xs text-[#6B7280] leading-relaxed hidden md:block">{s.desc}</p>
            </button>
          ))}
        </div>

        <div
          ref={ctaRef}
          style={{ transitionDelay: '100ms' }}
          className={`bg-[#EEF5FF] rounded-2xl p-6 sm:p-8 md:p-12 border border-[#1A56A0]/20 transition-all duration-700 ease-out ${ctaInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="grid md:grid-cols-3 gap-6 sm:gap-8 items-center">
            <div className="md:col-span-2">
              <h3 className="text-xl sm:text-2xl font-bold text-[#111827] mb-3">Not Sure What You Need?</h3>
              <p className="text-sm sm:text-base text-[#6B7280]">
                Our home comfort advisors will assess your home and recommend the right combination of services, systems, and upgrades, with full financing and rebate guidance included.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row md:flex-col gap-3">
              <button
                onClick={() => navigate('/book-appointment')}
                className="bg-[#C41E3A] text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer"
              >
                Schedule Free Assessment
              </button>
              <a href="tel:+18506698335" className="border border-[#1A56A0] text-[#1A56A0] px-6 py-3 rounded-lg text-sm font-semibold text-center hover:bg-[#1A56A0] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                Call (850) 669-8335
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
